(ns hai.admin-ui.users.groups.routes
  (:require
   [hai.admin-ui.users.groups.create :as create]
   [hai.admin-ui.users.groups.edit :as edit]
   [hai.admin-ui.users.groups.table :as table]
   [hai.ui.icons :as icons]
   [hai.web-app.routing :as routing]))

(defn routes
  []
  [(-> ["/groups"
        {::routing/window-title "People"
         :icon icons/outlined-groups}
        ["" {:name        :user/groups
             :label       "People"
             :breadcrumbs ["People"]
             :view        table/page}]]
       (into (edit/routes))
       (into (create/routes)))])
